import { render, staticRenderFns } from "./ScheduledMails.vue?vue&type=template&id=5b8e0a60&scoped=true"
import script from "./ScheduledMails.vue?vue&type=script&lang=js"
export * from "./ScheduledMails.vue?vue&type=script&lang=js"
import style0 from "./ScheduledMails.vue?vue&type=style&index=0&id=5b8e0a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e0a60",
  null
  
)

export default component.exports